import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { SearchIcon } from '@/assets/icons/SearchIcon';

import { advancedSearchOptionStyles as sx } from './AdvancedSearchOption.styles';

export const AdvancedSearchOption = () => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<Box sx={sx.root}>
			<Box sx={sx.iconContainer}>
				<SearchIcon sx={sx.icon} fill={theme.palette.primary.contrastText} />
			</Box>
			<Typography variant='body1' color='primary'>
				{t('Advanced Search')}
			</Typography>
		</Box>
	);
};
